import { Typography } from '@mui/material';
import { useIntl } from 'react-intl';

export function PoweredByTbOneFooter() {
  const intl = useIntl();

  return (
    <div className="w-full px-10 pt-0 mt-auto">
      <footer className="w-full flex flex-row-reverse items-center gap-1 pb-5">
        <img className="ml-1" src="/tradebyte/tb-one-logo-black.svg" alt="TB.ONE" width="61.41px" />

        <Typography variant="caption2">
          {intl.formatMessage({
            id: 'tb.one.disclaimer',
            defaultMessage: 'powered by',
          })}
        </Typography>
      </footer>
    </div>
  );
}
